export const merchantBusinessProfileCardClass =
  'rounded-merchant-stat bg-merchant-surface p-5 shadow-merchant-stat lg:p-6'
